export default function Anchor ({ children, className, ...attributes }) {
  return <a {...attributes} className={`font-bold underline text-black hover:text-gray-800 ${className}`}>{children}</a>
}

